import angular from 'angular';

import constantsModules from '../constants';

import LinksContextService from './links.service';

export default angular.module('fp:customerportal:shop:common:links', [
    constantsModules.name
])
.service('linklists', LinksContextService);